import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { postUserActivity } from "components/shared/postUserActivity";

export function TrackingLink({ to, children, activityProps, ...rest }) {
  const navigate = useNavigate();

  const handleClick = async (e) => {
    e.preventDefault();
    try {
      await postUserActivity(...activityProps);
    } catch (error) {
      // handle/log error if needed
    }
    navigate(to);
  };

  return (
    <Link
      style={{ textDecoration: "none", color: "black" }}
      to={to}
      {...rest}
      onClick={handleClick}
    >
      {children}
    </Link>
  );
}
